<template>
    <div class="score-history__item">
        <div class="column"><div class="write-on write-on-replenishment"> {{item.transactionMeta.label}}</div></div>
        <div class="column"> {{ item.createdAt }}</div>
        <div class="column">{{ item.userFullName }}</div>
        <div class="column"><div class="write-on-amount"> {{ (item.amount * item.transactionMeta.sign).toFixed(2) }}</div></div>
        <div class="column"> {{ item.currentAmount }}</div>
        <div class="column" v-if="item.orderType"><span>Продукт:</span>{{ product(item.orderType) }} ({{ item.mtsbuCode }})</div>
        <div class="column plug" v-else></div>
        <div class="column" v-if="item.company"><span>СК:</span> {{ item.company }}</div>
        <div class="column" v-else></div>
        <div class="column"><span>Джерело:</span> {{item.transactionMeta.source}}</div>
        <div class="column"><span>ID транзакції:</span> {{ item.id }}</div>
    </div>
</template>

<script>
export default {
    name: 'RowBlockInvoiceForClient',
    props: {
        item: {
            type: Object,
            default: () => {
                return {
                    id: null,
                    amount: null,
                    createdAt: null,
                    currentAmount: null,
                };
            },
        },
    },
    methods: {
        product(typeId) {
            return this.$_.find(this.$store.getters.ALL_ORDER_TYPES, { id: typeId })?.name;
        }
    }
}
</script>
